// A controller fetched only when a page has an element that wants it. The two
// room controllers are most of the script's weight, and the door, the join
// form and every page without a room never use them. esbuild splits each
// import() into its own file (package.json "build": --splitting).
export function registerLazy(application, identifier, load) {
  const selector = `[data-controller~="${identifier}"]`
  let observer = null

  const fetchIt = () => {
    observer?.disconnect()
    observer = null
    load().then((module) => application.register(identifier, module.default))
  }

  if (document.querySelector(selector)) return fetchIt()

  // Turbo swaps the body on a visit and streams replace parts of it, so the
  // first room may arrive long after this script ran.
  observer = new MutationObserver(() => {
    if (document.querySelector(selector)) fetchIt()
  })
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: [ "data-controller" ] })

  // A signed-in player is a page or two from their lair: fetch it once the
  // page is idle, so the room does not wait on it.
  if (document.querySelector('meta[name="ll-signed-in"]')) {
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500))
    window.addEventListener("load", () => idle(() => observer && fetchIt()), { once: true })
  }
}
